import {Component, inject, model, OnInit, signal, ViewChild} from '@angular/core';
import {InputComponent, InputOptions, SwitchComponent, SwitchOptions} from "@shared/components";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {APIService} from '@core/services';
import {Subject, takeUntil} from 'rxjs';
import {InputModes, InputTypes} from '@core/enums';
import {VaccinationCoding} from '@core/classes/other/vaccination-coding';
import {Coding} from '@core/classes/other/coding';

@Component({
  selector: 'ncp-illness-search',
    imports: [
        InputComponent,
        ReactiveFormsModule,
        SwitchComponent
    ],
  templateUrl: './illness-search.component.html',
  styleUrl: './illness-search.component.scss',
})
export class IllnessSearchComponent implements OnInit {
  @ViewChild('searchInput') public searchInput!: InputComponent
  private readonly apiService = inject(APIService)

  protected illnessSwitchOptions = signal<SwitchOptions>({});
  protected codeInputOptions = signal<InputOptions>({});
  protected descriptionInputOptions = signal<InputOptions>({});

  protected data = model<any>();
  protected isChecked: boolean = true;

  private subscription: any;
  private destroy$ = new Subject<void>();

  protected formGroup: FormGroup = new FormGroup({
    codeSearch: new FormControl<string>(''),
    descriptionSearch: new FormControl<string>(''),
  });

  get codeSearch() {
    return this.formGroup.get('codeSearch') as FormControl;
  }

  get descriptionSearch() {
    return this.formGroup.get('descriptionSearch') as FormControl;
  }

  ngOnInit() {
    this.codeInputOptions.set(
      new InputOptions({
        id: 'codeSearch',
        name: 'codeSearch',
        type: InputTypes.text,
        mode: InputModes.search,
        initialValue: '',
        formControl: this.codeSearch,
        onKeyUp: this.onKeyUp
      })
    );

    this.descriptionInputOptions.set(
      new InputOptions({
        id: 'descriptionSearch',
        name: 'descriptionSearch',
        type: InputTypes.text,
        mode: InputModes.search,
        initialValue: '',
        formControl: this.descriptionSearch,
        onKeyUp: this.onKeyUp
      })
    );

    this.illnessSwitchOptions = signal<SwitchOptions>(
      new SwitchOptions({
        id: 'switch',
        label: {
          text: 'code',
        },
        value: this.isChecked,
        onInput: (value) => {
          this.isChecked = value;
          console.log('value', value);
          let newSwtOptions = this.illnessSwitchOptions();
          newSwtOptions.label!.text = value ? 'code' : 'description';
          newSwtOptions.value = value;
        },
      })
    );
  }

  onKeyUp = (event: KeyboardEvent, value: string) => {
    console.log('onKeyUp', (event.target as HTMLInputElement).id + ' ' + this.isChecked);
    var api = ((event.target as HTMLInputElement).id === 'codeSearch')
      ? this.data().api.code
      : this.data().api.description;

    api.body!.description = value;

    console.log(this.data().api);
    console.log(api);

    api.body!.description = value;

    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.subscription = this.apiService
      .call(api)
      ?.pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res) {
          console.log(res);
          this.data().allData.set(res.data);
        }
      });
  }
}
